module.exports = __webpack_public_path__ + "img/CPa.b40d9808.png";